module.exports = __webpack_public_path__ + "static/uxpin_notepad_collection_2-a82a5b520d009f3fa9b19b3e382aeec6.png";